import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class OffsetService {
    private readonly rendererFactory = inject(RendererFactory2);


    private readonly renderer: Renderer2;

    constructor() {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    public setOffset(selector: string, element: HTMLElement) {
        // TODO replace this solution when (or if) popover libraries start to support zoom property
        // @ts-ignore
        const zoomLevel = +window.getComputedStyle(document.body).zoom;

        if (zoomLevel !== 1) {
            const offsetElement = document.querySelector(selector) as HTMLElement;

            const elementPanel = element.getBoundingClientRect();
            const selectPanel = offsetElement.getBoundingClientRect();

            let top = elementPanel.y + elementPanel.height;
            let left = elementPanel.x + (elementPanel.width - selectPanel.width) / 2;

            top = (top/ zoomLevel);
            left = (left / zoomLevel);

            this.renderer.setStyle(offsetElement, 'top', `${top}px`);
            this.renderer.setStyle(offsetElement, 'left', `${left}px`);
        }
    }
}
